export default __webpack_public_path__ + "static/media/banner.f885aae1.png";